import { render, staticRenderFns } from "./histogram.vue?vue&type=template&id=0d8488ae&scoped=true&"
import script from "./histogram.vue?vue&type=script&lang=js&"
export * from "./histogram.vue?vue&type=script&lang=js&"
import style0 from "./histogram.vue?vue&type=style&index=0&id=0d8488ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8488ae",
  null
  
)

export default component.exports